const Theme = {
  body_background_color: '#f0584f',

  logo_image_url: 'eaqcard.png',
  header_full_height: true,

  button_color: '#132360',
  button_font: `'Gotham', sans-serif`,
  button_text_size: 15,
  button_radius: 50,
  button_text_weight: 600,

  button_half_border_color: '#dfb23d',
  button_half_font: `'Gotham', sans-serif`,

  text_font: `'Arial', sans-serif`,

  title_font: `'Gotham', sans-serif`,

  separator_color: '#e24e97',

  footer_border_color: '#eee',
}

export default Theme
